/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  DisconnectProfileAccountOauthInput,
  ProfileAccount,
  ProfileAccountRequestInput,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Get Account Settings
 */
export const getProfileAccount = (

 signal?: AbortSignal
) => {


      return axiosClient<ProfileAccount>(
      {url: `/profile/account`, method: 'GET', signal
    },
      );
    }




export const getGetProfileAccountQueryKey = () => {
    return [
    'profile','account'
    ] as const;
    }


export const getGetProfileAccountQueryOptions = <TData = Awaited<ReturnType<typeof getProfileAccount>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileAccount>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetProfileAccountQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfileAccount>>> = ({ signal }) => getProfileAccount(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfileAccount>>, TError, TData>
}

export type GetProfileAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getProfileAccount>>>
export type GetProfileAccountQueryError = ErrorType<void>


/**
 * @summary Get Account Settings
 */

export function useGetProfileAccount<TData = Awaited<ReturnType<typeof getProfileAccount>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProfileAccount>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProfileAccountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Account Settings
 */
export const updateProfileAccount = (
    profileAccountRequestInput: MaybeRefOrGetter<ProfileAccountRequestInput>,
 signal?: AbortSignal
) => {
      profileAccountRequestInput = toValue(profileAccountRequestInput);

      return axiosClient<void>(
      {url: `/profile/account`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: profileAccountRequestInput, signal
    },
      );
    }




export const getUpdateProfileAccountMutationKey = () => ['updateProfileAccount'] as const;

export const getUpdateProfileAccountMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileAccount>>, TError,UpdateProfileAccountMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateProfileAccount>>, TError,UpdateProfileAccountMutationVariables, TContext> => {

const mutationKey = getUpdateProfileAccountMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProfileAccount>>, UpdateProfileAccountMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateProfileAccount(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProfileAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateProfileAccount>>>
    export type UpdateProfileAccountMutationBody = ProfileAccountRequestInput
    export type UpdateProfileAccountMutationError = ErrorType<SchemaValidationErrorResponse | ValidationError>
    export type UpdateProfileAccountMutationVariables = {data: ProfileAccountRequestInput}

    /**
 * @summary Update Account Settings
 */
export const useUpdateProfileAccount = <TError = ErrorType<SchemaValidationErrorResponse | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProfileAccount>>, TError,UpdateProfileAccountMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateProfileAccount>>,
        TError,
        UpdateProfileAccountMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateProfileAccountMutationOptions(options), queryClient);
    }
    /**
 * @summary Disconnect OAuth Provider
 */
export const disconnectProfileAccountOauth = (
    disconnectProfileAccountOauthInput: MaybeRefOrGetter<DisconnectProfileAccountOauthInput>,
 signal?: AbortSignal
) => {
      disconnectProfileAccountOauthInput = toValue(disconnectProfileAccountOauthInput);

      return axiosClient<ProfileAccount>(
      {url: `/profile/account/disconnect_oauth`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: disconnectProfileAccountOauthInput, signal
    },
      );
    }




export const getDisconnectProfileAccountOauthMutationKey = () => ['disconnectProfileAccountOauth'] as const;

export const getDisconnectProfileAccountOauthMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectProfileAccountOauth>>, TError,DisconnectProfileAccountOauthMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disconnectProfileAccountOauth>>, TError,DisconnectProfileAccountOauthMutationVariables, TContext> => {

const mutationKey = getDisconnectProfileAccountOauthMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectProfileAccountOauth>>, DisconnectProfileAccountOauthMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  disconnectProfileAccountOauth(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DisconnectProfileAccountOauthMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectProfileAccountOauth>>>
    export type DisconnectProfileAccountOauthMutationBody = DisconnectProfileAccountOauthInput
    export type DisconnectProfileAccountOauthMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type DisconnectProfileAccountOauthMutationVariables = {data: DisconnectProfileAccountOauthInput}

    /**
 * @summary Disconnect OAuth Provider
 */
export const useDisconnectProfileAccountOauth = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectProfileAccountOauth>>, TError,DisconnectProfileAccountOauthMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof disconnectProfileAccountOauth>>,
        TError,
        DisconnectProfileAccountOauthMutationVariables,
        TContext
      > => {
      return useMutation(getDisconnectProfileAccountOauthMutationOptions(options), queryClient);
    }
